<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import PriceOrAmountWithPromoCode from '~/components/modal-windows/PriceOrAmountWithPromoCode.vue'
import helpers from '~/helpers'

defineProps<{
  totalWithPromoCodeInKopecks: number
}>()

async function openPriceWithPromoCodeModalWindow (): Promise<void> {
  await useModal({ component: PriceOrAmountWithPromoCode, attrs: { isPrice: false } }).open()
}
</script>

<template>
  <div class="amount-with-promo-code flex items-center">
    <span
      class="amount-with-promo-code__amount text-white"
    >{{ helpers.formatPrice(totalWithPromoCodeInKopecks, true) }}&nbsp;₽</span>
    <SvgIcon
      class="amount-with-promo-code__help-icon ml-1 cursor-pointer"
      name="outlined/help-outline"
      @click="openPriceWithPromoCodeModalWindow"
    />
  </div>
</template>

<style lang="scss" scoped>
@use 'assets/css/variables';

.amount-with-promo-code {
  &__amount {
    background: variables.$itab-gradient;
    border-radius: 4px;
    font-weight: 700;
    padding: 4px 8px;
  }

  &__help-icon {
    color: variables.$main-green-color;
    font-size: 18px;

    &:hover {
      color: variables.$main-blue-color;
    }
  }
}
</style>
